module.exports = __webpack_public_path__ + "assets/img/elec.399ffdb6.svg";